import { Http } from "@/util";

/** 我发起的流程分页 */
export function getWorkflowProcessList(params) {
  return Http.post("/admin/workflow/process/list", params);
}

/** 我的待办任务分页 */
export function getWorkflowTaskTodo(params) {
  return Http.get("/admin/workflow/task/todo", params);
}

/** 我的已办任务分页 */
export function getWorkflowTaskDone(params) {
  return Http.get("/admin/workflow/task/done", params);
}

/** 创建流程 */
export function createWorkflowProcess(body) {
  return Http.post("/admin/workflow/process/create", body);
}

/** 按角色查询可选关联方（发起流程用） */
export function getWorkflowRelatedParties(params) {
  return Http.get("/admin/workflow/process/related-parties", { ...params, _useCache: true });
}

/** 发起人修改进行中的流程 */
export function updateWorkflowProcess(body) {
  return Http.post("/admin/workflow/process/update", body);
}

/** 按流程 ID 查询可选处理方式（关联方角色维度） */
export function getWorkflowHandleTypesByProcessId(params) {
  return Http.get("/admin/workflow/process/handle-types", params);
}

/** 流程详情（含任务树、日志） */
export function getWorkflowProcessDetail(id, params) {
  return Http.get(`/admin/workflow/process/detail/${id}`, params);
}

/** 流程操作轨迹 */
export function getWorkflowProcessTrace(id, params) {
  return Http.get(`/admin/workflow/process/trace/${id}`, params);
}

/** 完成任务 / 拒绝 / 指派下一任务 */
export function completeWorkflowTask(body) {
  return Http.post("/admin/workflow/task/complete", body);
}

/** 待处理 → 处理中，记录开始处理时间 */
export function startWorkflowTaskProcessing(taskId, params) {
  return Http.get(`/admin/workflow/task/start-processing/${taskId}`, params);
}

/** 执行人修改任务截止时间（记日志） */
export function updateWorkflowTaskDeadline(body) {
  return Http.post("/admin/workflow/task/deadline", body);
}

/** 拆分并行子任务 */
export function splitWorkflowTask(body) {
  return Http.post("/admin/workflow/task/split", body);
}

/** 任务详情 */
export function getWorkflowTaskDetail(id, params) {
  return Http.get(`/admin/workflow/task/detail/${id}`, params);
}

/** 附件列表分页查询（支持按类型过滤、关键词搜索、上传者 id；uploaderId=-1 表示无上传人） */
export function getWorkflowAttachmentList(params) {
  return Http.get("/admin/workflow/attachment/list", params);
}

/** 附件详情 */
export function getWorkflowAttachmentDetail(id) {
  return Http.get(`/admin/workflow/attachment/detail/${id}`);
}

/** 添加附件 */
export function addWorkflowAttachment(body) {
  return Http.post("/admin/workflow/attachment/add", body);
}

/**
 * 按流程 processId 生成罚单草稿（后台从流程解析 todoId），参数走 query 便于 @RequestParam 绑定
 */
export function getWorkflowPunishBillByProcess(processId) {
  return Http.get(`/admin/workflow/get/punish-bill`, { processId });
}
